import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as customerProjectsActions from 'app/store/temporary/actions/customer-projects.actions';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MwCustomerProjectsApiService } from 'app/services/customer-projects-api.service';
import * as notifyActions from 'app/store/general/actions/notify.actions';
import { Store } from '@ngrx/store';
import { AddressFormatter } from 'app/components/map/map.models';

@Injectable()
export class CustomerProjectsEffects {
  loadCustomerProjects$ = createEffect(() =>
    this.actions$.pipe(
      ofType(customerProjectsActions.loadCustomerProjects),
      switchMap(({ loadOptions }) =>
        this.customerProjectsApiService.getCustomerProjects(loadOptions).pipe(
          // Add formatted address
          map((response) => {
            response.results.map((item) => {
              item.formattedAddress = AddressFormatter.format(item);
              return item;
            });
            return response;
          }),
          map((response) =>
            customerProjectsActions.loadCustomerProjectsSuccess({ response })
          ),
          catchError((error) =>
            of(customerProjectsActions.loadCustomerProjectsFailed({ error }))
          )
        )
      )
    )
  );

  createCustomerProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(customerProjectsActions.createCustomerProject),
      switchMap(({ customerProject }) =>
        this.customerProjectsApiService
          .createCustomerProject(customerProject)
          .pipe(
            switchMap(() => [
              customerProjectsActions.createCustomerProjectSuccess(),
              notifyActions.notifySuccess({
                notification: {
                  phrase: 'OPERATION.add_customer_project_successful',
                },
              }),
            ]),
            catchError((error) =>
              of(customerProjectsActions.createCustomerProjectFailed({ error }))
            )
          )
      )
    )
  );

  updateCustomerProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(customerProjectsActions.updateCustomerProject),
      switchMap(({ customerProject }) =>
        this.customerProjectsApiService
          .updateCustomerProject(customerProject)
          .pipe(
            switchMap((response) => [
              customerProjectsActions.updateCustomerProjectSuccess(),
              notifyActions.notifySuccess({
                notification: {
                  phrase: 'OPERATION.edit_customer_project_successful',
                },
              }),
            ]),
            catchError((error) =>
              of(customerProjectsActions.updateCustomerProjectFailed({ error }))
            )
          )
      )
    )
  );

  deleteCustomerProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(customerProjectsActions.deleteCustomerProject),
      switchMap(({ customerProject }) =>
        this.customerProjectsApiService
          .deleteCustomerProject(customerProject)
          .pipe(
            switchMap(() => [
              customerProjectsActions.deleteCustomerProjectSuccess(),
              notifyActions.notifySuccess({
                notification: {
                  phrase: 'OPERATION.delete_customer_project_successful',
                },
              }),
            ]),
            catchError((error) =>
              of(customerProjectsActions.deleteCustomerProjectFailed({ error }))
            )
          )
      )
    )
  );

  deleteCustomerProjectsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(customerProjectsActions.deleteCustomerProjectsList),
      switchMap(({ customerProjects }) =>
        this.customerProjectsApiService
          .deleteCustomerProjectList(customerProjects)
          .pipe(
            switchMap(() => [
              customerProjectsActions.deleteCustomerProjectsListSuccess(),
              notifyActions.notifySuccess({
                notification: {
                  phrase: 'OPERATION.delete_customer_projects_successful',
                },
              }),
            ]),
            catchError((error) =>
              of(
                customerProjectsActions.deleteCustomerProjectsListFailed({
                  error,
                })
              )
            )
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store$: Store<any>,
    private customerProjectsApiService: MwCustomerProjectsApiService
  ) {}
}
